import React from "react";
import { GridCellKind, measureTextCached } from "@glideapps/glide-data-grid";
import "../../../icons/Icon.js";
import { customIconCharacterMapping } from "../../../icons/types.js";
import "../../../icons/ExpandMoreIcon.js";
import { CanvasRenderingContext2DExtended } from "../CanvasRenderingContext2DExtended.js";
import { rowHeight } from "../types.js";
const invalidCellKind = "invalid_data";
function getInvalidDataCell(value) {
  return {
    kind: GridCellKind.Custom,
    copyData: value.stringifiedModel,
    data: {
      kind: invalidCellKind,
      value,
      tooltip: InvalidDataCellTooltipContent
    },
    allowOverlay: false
  };
}
function getInvalidDataCellRenderer(muiTheme) {
  return {
    kind: GridCellKind.Custom,
    isMatch: (cell) => cell.data.kind === invalidCellKind,
    needsHover: true,
    needsHoverPosition: true,
    draw: ({ ctx, theme, rect }) => {
      const fontSizeProperty = muiTheme.typography.body1.fontSize;
      const fontSize = typeof fontSizeProperty === "string" ? Number.parseInt(fontSizeProperty) : fontSizeProperty;
      ctx.fillStyle = muiTheme.palette.error.main;
      const textCtx = new CanvasRenderingContext2DExtended(ctx);
      ctx.font = `${fontSize}px icomoon`;
      const icon = customIconCharacterMapping.ErrorCircleOutline;
      const drawArea = {
        x: rect.x + theme.cellHorizontalPadding,
        y: rect.y + theme.cellVerticalPadding,
        width: rect.width - 2 * theme.cellHorizontalPadding,
        height: rect.height - 2 * theme.cellVerticalPadding
      };
      ctx.fillText(icon, drawArea.x, drawArea.y + rowHeight / 2);
      const { width: iconWidth } = measureTextCached(icon, ctx);
      const iconPadding = 4;
      ctx.font = `${fontSize}px ${theme.fontFamily}`;
      textCtx.fillTextWithEllipsis(
        "Invalid Data",
        drawArea.width - (iconWidth + iconPadding),
        drawArea.x + (iconWidth + iconPadding),
        drawArea.y + rowHeight / 2
      );
    }
  };
}
function InvalidDataCellTooltipContent({ value }) {
  return /* @__PURE__ */ React.createElement("div", null, value?.stringifiedModel);
}
export {
  getInvalidDataCell,
  getInvalidDataCellRenderer
};
//# sourceMappingURL=GlideInvalidDataCell.js.map
